import React, { useEffect, createElement } from 'react';
const PIXEL_ID = '1846495476046411';
declare global {
  interface Window {
    fbq?: ((...args: unknown[]) => void) & {
      callMethod?: (...args: unknown[]) => void;
      queue?: unknown[];
      loaded?: boolean;
      version?: string;
      push?: (...args: unknown[]) => void;
    };
    _fbq?: unknown;
  }
}
/**
 * Meta Pixel — initializes the pixel and fires a PageView event on mount.
 * Safe variant of the official Meta base code that doesn't assume an
 * existing <script> tag is in the DOM (which is true for React SPAs).
 */
export function MetaPixel() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    // If already initialised (HMR / second mount), just re-track PageView
    if (window.fbq) {
      window.fbq('track', 'PageView');
      return;
    }
    /* eslint-disable @typescript-eslint/no-explicit-any */
    const f = window as any;
    const b = document;
    const n: any = function (...args: unknown[]) {
      n.callMethod ? n.callMethod.apply(n, args) : n.queue.push(args);
    };
    f.fbq = n;
    if (!f._fbq) f._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    /* eslint-enable @typescript-eslint/no-explicit-any */
    // Inject the loader script. Append to <head> directly — this avoids the
    // "Cannot read properties of undefined (reading 'parentNode')" error
    // when no other <script> element is present in the document.
    const t = b.createElement('script');
    t.async = true;
    t.src = 'https://connect.facebook.net/en_US/fbevents.js';
    (b.head || b.getElementsByTagName('head')[0] || b.documentElement).appendChild(t);
    window.fbq?.('init', PIXEL_ID);
    window.fbq?.('track', 'PageView');
  }, []);
  return <noscript data-id="element-152">
      <img height="1" width="1" style={{
      display: 'none'
    }} alt="" src={`https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-153" />
    </noscript>;
}